(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('demax-launch-purchase')) {
  customElements.define('demax-launch-purchase', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.active = true;
      this.end = Number(this.dataset.end);
      this.waiting = Date.now() < this.end || (Date.now() < this.end + 900000 && this.dataset.open !== 'true');
      this.nextCheck = 0;
      this.attempts = 0;
      this.check = () => {
        if (!Number.isFinite(this.end) || this.dataset.future === 'true') {
          this.hidden = true;
          return;
        }
        const before = Date.now() < this.end;
        this.hidden = before;
        if (before || !this.waiting || window.Shopify?.designMode) return;
        if (this.attempts >= 180) {
          this.waiting = false;
          return;
        }
        if (!this.busy && Date.now() >= this.nextCheck && document.visibilityState !== 'hidden') {
          this.refreshAvailability();
        }
      };
      this.check();
      this.timer = setInterval(this.check, 1000);
      this.onVisible = () => { this.nextCheck = 0; this.check(); };
      document.addEventListener('visibilitychange', this.onVisible);
    }
    async refreshAvailability() {
      this.busy = true;
      this.attempts += 1;
      this.nextCheck = Date.now() + 5000;
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin || !this.dataset.section) return;
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('variant', this.dataset.variant);
        url.searchParams.set('_demax_check', String(Date.now()));
        const response = await fetch(url, {cache: 'no-store', credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.active || controller.signal.aborted) return;
        const fresh = Array.from(html.querySelectorAll('demax-launch-purchase')).find(el => el.dataset.product === this.dataset.product && el.dataset.variant === this.dataset.variant && el.dataset.section === this.dataset.section);
        if (!fresh || fresh.dataset.future === 'true' || fresh.dataset.open !== 'true') return;
        const destination = new URL(window.location.href);
        const attempts = Number(destination.searchParams.get('_demax_launch') || 0);
        if (!Number.isInteger(attempts) || attempts >= 3) return;
        destination.searchParams.set('variant', this.dataset.variant);
        destination.searchParams.set('_demax_launch', String(attempts + 1));
        destination.searchParams.set('_demax_at', String(Date.now()));
        this.waiting = false;
        window.location.replace(destination.href);
      } catch (error) {
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) {
          this.busy = false;
          this.controller = null;
        }
      }
    }
    disconnectedCallback() {
      this.active = false;
      clearInterval(this.timer);
      this.controller?.abort();
      document.removeEventListener('visibilitychange', this.onVisible);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["demax-serie-2-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('demax-launch-countdown')) {
  customElements.define('demax-launch-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const update = () => {
        const end = Number(this.dataset.end);
        if (!Number.isFinite(end)) return;
        const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        ['days', 'hours', 'minutes', 'seconds'].forEach((unit, i) => {
          const target = this.querySelector('[data-unit="' + unit + '"]');
          if (target) target.textContent = String(values[i]).padStart(2, '0');
        });
        this.hidden = seconds === 0;
      };
      update();
      this.timer = setInterval(update, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["demax-serie-2-cta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('demax-launch-cta')) {
  customElements.define('demax-launch-cta', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const update = () => {
        const link = this.querySelector('a');
        const end = Number(this.dataset.end);
        if (!link || !Number.isFinite(end)) return;
        const label = Date.now() >= end ? this.dataset.after : this.dataset.before;
        if (link.textContent.trim() !== label) link.textContent = label;
      };
      update();
      this.timer = setInterval(update, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
